import { render } from "./FormGroup.vue?vue&type=template&id=38668d35"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"
script.render = render

export default script